import useUser from '../../../hooks/User';
import BCard from '../../../components/ui/generic/BCard';
import { formatDateFront, getAgeFromDateString } from '../../../utils';
import { BBadge, BButton } from '../../../components/ui/generic';
import { variant } from '../../../components/ui/generic/utils';
import axiosInstance from '../../../utils/AxiosInstance';
import { useEffect, useState } from 'react';
import { useHeader } from '../../../context/HeaderContext';

const DashboardProfile = () => {
  const { data } = useUser();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { setTitle, setDescription } = useHeader();

  useEffect(() => {
    setTitle('Vos données');
    setDescription(' ');
  }, [setDescription, setTitle]);
  const handleCardChange = async (e) => {
    setIsSubmitting(true);
    e.preventDefault();
    const res = await axiosInstance.post('/internal_api/payment-method/create', {
      success_url: `${import.meta.env.VITE_APP_URL}/mes-infos/carte/succes`,
      cancel_url: `${import.meta.env.VITE_APP_URL}/mes-infos`,
      //cancel_url: `${import.meta.env.VITE_APP_URL}/mes-infos/carte/echec`,
    });

    console.log(res)
    setIsSubmitting(false);
    if (res.status === 200) {
      const { data } = res;
      if (!data.error) {
        if (data?.data?.url) {
          window.location.href = data?.data?.url;
        }
      }
    }
  };
  return (
    <div className={'flex flex-wrap gap-6'}>
      <BCard maxSize={'lg:max-w-sm'}>
        <BCard.Header withTitle title={'Situation personnelle'}></BCard.Header>
        <BCard.Body withDivider>
          <BCard.Label label={'Genre'}>{data?.gender}</BCard.Label>
          <BCard.Label label={'Situation professionnelle'}>{data?.situation_pro ?? 'Non spécifié'}</BCard.Label>
          <BCard.Label label={"Niveau d'étude"}>{data?.school_level ?? 'Non spécifié'}</BCard.Label>
          <BCard.Label label={'Durée hebdomadaire'}>{data?.occupationDuration ?? 'Non spécifié'}</BCard.Label>
          <BCard.Label label={'Situation familiale'}>{data?.family_situation ?? 'Non spécifié'}</BCard.Label>
          <BCard.Label label={'Âge'}>
            {data?.birth_day
              ? `${getAgeFromDateString(data?.birth_day)} ans (${formatDateFront(data?.birth_day)})`
              : 'Non spécifié'}
          </BCard.Label>
        </BCard.Body>
      </BCard>
      <BCard maxSize={'lg:max-w-sm'}>
        <BCard.Header withTitle title={'Contact élève'}></BCard.Header>
        <BCard.Body withDivider>
          <BCard.Label label={'Email'}>{data?.email ?? 'Non spécifié'}</BCard.Label>
          <BCard.Label label={'Téléphone'}>{data?.phone ?? 'Non spécifié'}</BCard.Label>
          <BCard.Label label={'Adresse'}>{data?.address ?? 'Non spécifié'}</BCard.Label>
          <BCard.Label label={'Code postal'}>{data?.postal_code ?? 'Non spécifié'}</BCard.Label>
          <BCard.Label label={'Ville'}>{data?.city ?? 'Non spécifié'}</BCard.Label>
          <BCard.Label label={'Pays'}>{data?.country ?? 'Non spécifié'}</BCard.Label>
        </BCard.Body>
      </BCard>
      <BCard maxSize={'lg:max-w-sm'}>
        <BCard.Header withTitle title={'Coordonnées bancaire'}>
          <BButton
            isDisabled={isSubmitting}
            isProcessing={isSubmitting}
            onClick={handleCardChange}
            label={'Mettre à jour ma Carte Bancaire'}
          />
        </BCard.Header>
      </BCard>
    </div>
  );
};

export default DashboardProfile;
